<template>
  <v-row
    :class="mobile ? 'pt-10' : 'mx-0 mt-0 mb-n10 welcome-background'"
    align="center"
    justify="center"
  >
    <v-col>
      <h1 class="welcome-title">
        {{ t("startPageStrings.pageHeader") }}
      </h1>
    </v-col>
  </v-row>
</template>

<script setup>
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';

const { mobile } = useDisplay();
const { t } = useI18n();

</script>

<style lang="scss" scoped>
@mixin gradient-image($bgcolor, $image) {
  background: $bgcolor;
  background: linear-gradient(
  90deg,
  $bgcolor 35%,
  rgba(0, 0, 0, 0) 75%,
  rgba(0, 0, 0, 0) 100%
  ),
  $image;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: right;
  background-position-y: center;
}

@media screen {
  .welcome-background {
    @include gradient-image(rgb(var(--v-theme-primary)), url("~@/assets/relay.jpg"));
    height:180px;
  }
  .welcome-title {
    color: rgb(var(--v-theme-background));
    font-weight: lighter;
    font-size: 2.75rem;
    text-align: center;
  }
}
</style>
